import { EditIcon } from '@chakra-ui/icons';
import { TbTrash } from 'react-icons/tb';

import ActionsButton from 'components/tables/AGGrid/ActionsButton';

/**
 * Builds the AG Grid column definitions for the Templates table.
 *
 * @param {object}   params
 * @param {function} params.onEditTemplate   Called with the row data when the edit action is clicked.
 * @param {function} params.onDeleteTemplate Called with the row data when the delete action is clicked.
 * @returns {Array} AG Grid column definitions.
 */
export const getTemplatesTableColumns = ({
    onEditTemplate,
    onDeleteTemplate,
}) => [
    {
        headerName: 'ID',
        field: 'id',
        flex: 1,
        minWidth: 100,
        sort: 'asc',
    },
    {
        headerName: 'Name',
        field: 'name',
        flex: 1,
        minWidth: 150,
    },
    {
        headerName: 'Action',
        maxWidth: 100,
        filter: false,
        suppressMovable: true,
        lockVisible: true,
        suppressColumnsToolPanel: true,
        suppressHeaderMenuButton: true,
        suppressHeaderFilterButton: true,
        enableRowGroup: false,
        resizable: false,
        sortable: false,
        cellStyle: () => ({ display: 'flex', alignItems: 'center' }),
        lockPosition: 'right',
        cellRenderer: (params) => (
            <ActionsButton
                actions={[
                    {
                        label: 'Edit',
                        icon: EditIcon,
                        onClick: () => onEditTemplate(params.data),
                    },
                    {
                        label: 'Delete',
                        icon: TbTrash,
                        onClick: () => onDeleteTemplate(params.data),
                    },
                ]}
            />
        ),
    },
];
